var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBusca01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-busca-2",
    transform: "translate(0 0.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1239",
    d: "M20.2,30.2c-8.5,0-15.3-6.9-15.3-15.3S11.7-0.4,20.2-0.4s15.3,6.9,15.3,15.3S28.7,30.2,20.2,30.2z  M20.2,3.9c-6,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11l0,0C31.2,8.9,26.2,3.9,20.2,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1240",
    d: "M2.7,34.6c-1.2,0-2.2-1-2.2-2.2c0-0.6,0.2-1.1,0.6-1.6l0,0l8.2-8.2c0.9-0.9,2.3-0.9,3.2,0 c0.9,0.9,0.9,2.3,0,3.2c0,0,0,0-0.1,0.1L4.2,34C3.8,34.4,3.3,34.6,2.7,34.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBusca01);
export default __webpack_public_path__ + "static/media/ico-busca-01.34950ae2f07cffab1c09b77ebee77bf2.svg";
export { ForwardRef as ReactComponent };